import { Router } from 'vue-router'
import { computed } from 'vue'
import { useSettingStore, useTabStore, useAuthStore } from '@jms/store'
import isObject from 'lodash/isObject'
import { restructureMeta } from '@jms/utils'
import type { MenuItemIn } from '@jms/layout/menu/menus'
import { versionCheck } from '@jms/utils/versionChecked'
const flatMenus = (menus: any) => {
  return menus.reduce((acc, curr) => {
    if (!curr?.childs?.length) {
      acc.push(curr)
    } else {
      acc = [...acc, { ...curr, childs: [] }, ...curr.childs]
    }
    return acc
  }, [] as MenuItemIn[])
}

//获取url所在对象
const getItemByUrl = (url: string | number) => {
  const authStore = useAuthStore()
  const menus = computed(() => authStore.menu || [])
  return flatMenus(menus.value).find((_) => _.path === url)
}

function setMenuStatus(this: any, findMenu: MenuItemIn) {
  if (!isObject(findMenu)) return
  this.setSelectedKeys([findMenu.id])
}

const routerBefore = (router: Router) => {
  router.beforeEach(async (to, from, next) => {
    await versionCheck('/version.json')
    const settingStore = useSettingStore()
    const tabStore = useTabStore()
    const authStore = useAuthStore()

    const findMenu = getItemByUrl(to.path) as MenuItemIn
    const hasPermission = isObject(flatMenus(authStore.menu).find((_) => _.path === to.path))
    if (to.name !== 'Login') {
      if (to.meta.requiresAuth && !authStore.isLoggedIn) {
        next({ name: 'Login' })
      }
      if (hasPermission) {
        next()
        //处理菜单选中状态
        setMenuStatus.call(settingStore, findMenu)
        tabStore.setTabs({ name: to.name as string, path: to.fullPath, meta: restructureMeta(to) })
      } else {
        to.name !== 'NoAuth' ? next({ name: 'NoAuth' }) : next()
      }
    } else {
      next()
    }
  })
}

export default routerBefore
